import router from '@/router/student'
import { useErrorStore } from '@/store/student/error_store'

const redirect_error_page = async (e): Promise<void> => {
    if(e.response) {
        let message: string = ""
        let code: any = ""
        if(e.response.status == 500){
            message = "Internal Server Error"
            code = e.response.status
        }else if(e.response.status == 503){
            message = "Service Unavailable"
            code = e.response.status
        }else if(e.response.data.error){
            message = e.response.data.error.message
            code = e.response.data.error.code
        }
        else{
            message = "Internal Server Error"
            code = e.response.status
        }
        useErrorStore().saveErrorMessageAndCode(message, code)
        await router.push({name: 'error'})
    }
    else {
        throw e
    }
}
export default redirect_error_page
